/** A small in-content loader used inside AppLayout.
 *  Keeps the sidebar mounted; only the content slot blinks. */
export default function PageLoader() {
    return (
        <div className="flex items-center justify-center py-20 text-ink-500">
            <div className="h-8 w-8 rounded-full border-2 border-brand-teal border-t-transparent animate-spin" />
        </div>
    );
}
